import script from "./HrAssistantAccessSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrAssistantAccessSettings.vue?vue&type=script&lang=ts&setup=true"

import "./HrAssistantAccessSettings.vue?vue&type=style&index=0&id=0ef0ae76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef0ae76"]])

export default __exports__